export default __webpack_public_path__ + "static/media/info_blue.487ba7de.svg";